import { CountryCode } from '~shared/constants/country-code.enum';

export const VAT_NUMBERS = {
  [CountryCode.Germany]: '',
  [CountryCode.Spain]: '',
  [CountryCode.Italy]: 'IT 00334679990',
  [CountryCode.Portugal]: ''
};
